export default{
  searchIndexes: state => state.searchIndexes,
  activeSearchIndex: state => state.activeSearchIndex,
};
